document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('input[name="purchase-option"]')
    .forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const selectedOption = event.target.id;
        document
          .querySelectorAll(".loop-widget-purchase-option")
          .forEach((option) => {
            option.classList.remove("loop-widget-purchase-option-selected");
          });
        if (selectedOption === "onetime-purchase-radio") {
          document
            .querySelector(".loop-widget-purchase-option-onetime")
            .classList.add("loop-widget-purchase-option-selected");
        } else if (selectedOption === "subscribe-save-radio") {
          document
            .querySelector(
              "#loop-widget-purchase-option-id-091440bb412697c5c97504cf99d91f4cfaf82095",
            )
            .classList.add("loop-widget-purchase-option-selected");
        }
      });
    });

  // Countdown Timer
  // Set the countdown time (15 minutes from now)
  var countdownTime = new Date().getTime() + 30 * 60 * 1000;

  // Update the countdown every second
  var countdownInterval = setInterval(function () {
    var now = new Date().getTime();
    var distance = countdownTime - now;

    // Calculate minutes and seconds
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result
    const minutesEl = document.querySelector(".countdown-timer .minutes");
    const secondsEl = document.querySelector(".countdown-timer .seconds");

    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");

    // If the countdown is over, clear the interval
    if (distance <= 0) {
      clearInterval(countdownInterval);
      if (minutesEl) minutesEl.textContent = "00";
      if (secondsEl) secondsEl.textContent = "00";
    }
  }, 1000);
});

const changeSaveDesc = () => {
  console.log("is_notin_target_collection", "3");

  if (window.checkoutBundleVars.isInTargetCollection) {
    const loopPurchaseOptionsDiscountBadge = document.querySelector(
      ".loop-widget-purchase-option-discount-badge",
    );
    let activeDiscountPercent = document.querySelector(
      ".is-active .save .save-sub",
    );
    const loopPurchaseOptionsDescription = document.querySelectorAll(
      ".loop-widget-purchase-option .loop-widget-sp-selector-description",
    );

    const loopPurchaseOptions = document.querySelector(
      ".loop-widget-purchase-option-selected .loop-widget-purchase-option-label",
    );

    if (
      loopPurchaseOptionsDiscountBadge &&
      loopPurchaseOptionsDiscountBadge.innerHTML.includes("%")
    ) {
      loopPurchaseOptionsDiscountBadge.innerHTML =
        activeDiscountPercent && activeDiscountPercent.innerHTML.includes("%")
          ? activeDiscountPercent.innerHTML
          : "Save 10%";
    }

    loopPurchaseOptionsDescription.forEach(
      (loopPurchaseOptionsDescriptionElement) => {
        if (
          loopPurchaseOptionsDescriptionElement.innerHTML.includes("Save") &&
          loopPurchaseOptionsDescriptionElement.innerHTML.includes("%")
        ) {
          loopPurchaseOptionsDescriptionElement.innerHTML =
            loopPurchaseOptionsDescriptionElement.innerHTML.replace(
              /Save \d+%/,
              activeDiscountPercent
                ? activeDiscountPercent.innerHTML
                : "Save 10%",
            );
        }
      },
    );
  }
};

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".save-var1")
    .forEach((el) => (el.style.display = "none"));

  setTimeout(() => {
    changeSaveDesc();
  }, 1500);

  const loopWidgetContainer = document.querySelector(".loop-widget-container");
  if (loopWidgetContainer) {
    loopWidgetContainer.addEventListener("click", function (event) {
      const loopPurchaseOptions = document.querySelector(
        ".loop-widget-purchase-option-selected .loop-widget-purchase-option-label",
      );
      const saveFlatSpans = document.querySelectorAll(".save .save-flat");
      const saveSubSpans = document.querySelectorAll(".save .save-sub");

      if (
        loopPurchaseOptions &&
        loopPurchaseOptions.innerHTML === "One-time purchase"
      ) {
        document
          .querySelectorAll(".sizeselector-flatprice")
          .forEach((el) => (el.style.display = "block"));
        document
          .querySelectorAll(".sizeselector-subprice")
          .forEach((el) => (el.style.display = "none"));
        document
          .querySelectorAll(".save-var1")
          .forEach((el) => (el.style.display = "none"));
        saveFlatSpans.forEach((el) => (el.style.display = "block"));
        saveSubSpans.forEach((el) => (el.style.display = "none"));
        document
          .querySelectorAll(".newpricetagtest")
          .forEach((el) => (el.style.display = "none"));
      } else {
        document
          .querySelectorAll(".sizeselector-flatprice")
          .forEach((el) => (el.style.display = "none"));
        document
          .querySelectorAll(".sizeselector-subprice")
          .forEach((el) => (el.style.display = "block"));
        saveFlatSpans.forEach((el) => (el.style.display = "none"));
        saveSubSpans.forEach((el) => (el.style.display = "block"));

        document
          .querySelectorAll(".save-var1")
          .forEach((el) => (el.style.display = "block"));
        document
          .querySelectorAll(".newpricetagtest")
          .forEach((el) => (el.style.display = "block"));
      }

      changeSaveDesc();
    });
  }

  const customSelectButton = document.querySelector(".custom-selectbutton");
  if (customSelectButton) {
    customSelectButton.addEventListener("click", function (event) {
      const loopPurchaseOptions = document.querySelector(
        ".loop-widget-purchase-option-selected .loop-widget-purchase-option-label",
      );
      // const activeSubprice = document.querySelector('.is-active .sizeselector-subprice');

      const priceHiddentFlatprice = document.querySelector(
        ".is-active .pricehidden-flatprice",
      );
      const priceHiddentSubprice = document.querySelector(
        ".is-active .pricehidden-subprice",
      );
      console.log("priceHiddentFlatprice", priceHiddentFlatprice);
      console.log("priceHiddentSubprice", priceHiddentSubprice);
      const loopWidgetSubsPrice = document.querySelector(
        ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price",
      );
      const loopWidgetOneTimePrice = document.querySelector(
        ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price",
      );

      if (priceHiddentFlatprice && priceHiddentSubprice) {
        if (loopWidgetSubsPrice)
          loopWidgetSubsPrice.innerHTML = priceHiddentSubprice.value;
        if (loopWidgetOneTimePrice)
          loopWidgetOneTimePrice.innerHTML = priceHiddentFlatprice.value;
      }

      if (
        loopPurchaseOptions &&
        loopPurchaseOptions.innerHTML != "One-time purchase"
      ) {
        changeSaveDesc();
      }

      if (
        window.checkoutBundleVars.requestPath == "/pages/checkout-bb-sherri"
      ) {
        const selectedBroth = document.querySelector(".selected-broth");
        const activeSubprice = document.querySelector(
          ".is-active .sizeselector-subprice",
        );
        if (selectedBroth && activeSubprice) {
          const selectedProduct = selectedBroth.getAttribute(
            "data-size-based-image",
          );
          if (selectedProduct == "true") {
            const dataValue = activeSubprice.getAttribute("data-id");
          if (selectedProduct == "true") {
            const dataValue = activeSubprice.getAttribute("data-id");
            const splideElement = document.querySelector(
              ".product__media-slider .x-splide",
            );
            if (splideElement && splideElement.splide) {
              splideElement.splide.go(dataValue - 1);
            }
          }
          }
        }
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("ingredientsModal");
  if (modal) {
    const modalImg = modal.querySelector(".modal-img");
    const modalCloseButton = modal.querySelector(".btn-close");
    const modalOverlay = modal.querySelector(".modal-dialog");

    // Open modal when "View Nutrition" button is clicked
    document.querySelectorAll(".modalTrigger").forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const imgSrc = this.getAttribute("data-bs-target");
        if (imgSrc) {
          modalImg.src = imgSrc;
        }
        modal.classList.add("show");
        modal.style.display = "block";
      });
    });

    // Close modal when close button or overlay is clicked
    const closeModal = () => {
      modal.classList.remove("show");
      modal.style.display = "none";
      modalImg.src = ""; // Clear image source
    };

    if (modalCloseButton)
      modalCloseButton.addEventListener("click", closeModal);
    modal.addEventListener("click", function (event) {
      if (!modalOverlay.contains(event.target)) {
        closeModal();
      }
    });
  }

  const priceHiddentFlatprice = document.querySelector(
    ".is-active .pricehidden-flatprice",
  );
  const priceHiddentSubprice = document.querySelector(
    ".is-active .pricehidden-subprice",
  );
  const loopWidgetSubsPrice = document.querySelector(
    ".loop-widget-purchase-option-subscription .loop-widget-purchase-option-price",
  );
  const loopWidgetOneTimePrice = document.querySelector(
    ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price",
  );
  if (priceHiddentFlatprice && priceHiddentSubprice) {
    if (loopWidgetSubsPrice)
      loopWidgetSubsPrice.innerHTML = priceHiddentSubprice.value;
    if (loopWidgetOneTimePrice)
      loopWidgetOneTimePrice.innerHTML = priceHiddentFlatprice.value;
  }

  const defaultValue = window.checkoutBundleVars.defaultValue;
  const defaultSpan = document.querySelector(
    `.span-wrap[data-value='${defaultValue}']`,
  );
  if (defaultSpan) defaultSpan.click();
});

document
  .querySelectorAll(".static-cta button, button.scroll")
  .forEach((button) => {
    button.addEventListener("click", () => {
      const productForm = document.querySelector(".options-bracket");
      if (productForm) {
        // offsetTop is relative to the nearest positioned ancestor, not the
        // document, so measure from the viewport instead.
        const stickyHeader = document.querySelector("#header");
        const stickyPosition = stickyHeader
          ? getComputedStyle(stickyHeader).position
          : "";
        const headerOffset =
          stickyPosition === "sticky" || stickyPosition === "fixed"
            ? stickyHeader.offsetHeight
            : 0;
        const scrollDistance =
          productForm.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset -
          12;

        window.scrollTo({
          top: Math.max(scrollDistance, 0),
          behavior: "smooth",
        });
      }
    });
  });

const product__submit = document.querySelectorAll(".submit");
if (product__submit) {
  product__submit.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      let productId = window.checkoutBundleVars.productVariantsFirstId;
      if (window.checkoutBundleVars.purchaseOptionType == "subscription") {
        window.location.href = `https://drkellyann.com/cart/clear?return_to=%2Fcart%2Fadd%3Fitems%5B0%5D%5Bid%5D%3D${productId}%26items%5B0%5D%5Bquantity%5D%3D1%26return_to%3D%2Fcheckout`;
      } else {
        const variantIds = window.checkoutBundleVars.cartVariantIds || [productId];
        const discountCode = window.checkoutBundleVars.discountCode || "21DAYBB125";
        const items = variantIds
          .map((id, i) => `items[${i}][id]=${id}&items[${i}][quantity]=1`)
          .join("&");
        const cartAddUrl = `/cart/add?${items}&return_to=${encodeURIComponent(`/checkout?discount=${discountCode}`)}`;
        window.location.href = `https://drkellyann.com/cart/clear?return_to=${encodeURIComponent(cartAddUrl)}`;
      }
    });
  });
}

const subsubmit = document.querySelectorAll(".subsubmit");
if (subsubmit) {
  subsubmit.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      let productId = window.checkoutBundleVars.productVariantsFirstId;
      window.location.href = `https://drkellyann.com/cart/clear?return_to=%2Fcart%2Fadd%3Fitems%5B0%5D%5Bid%5D%3D${productId}%26items%5B0%5D%5Bquantity%5D%3D1%26items%5B0%5D%5Bselling_plan%5D%3D2122481777%26return_to%3D%2Fcheckout%3Fdiscount%3D21DAYBBSUB125`;
    });
  });
}
